/**
 * Loading Component
 * Various loading states
 */

import React from 'react';

const Loading = ({ type = 'spinner', message = 'Loading...', size = 'md' }) => {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  if (type === 'fullPage') {
    return (
      <div className="fixed inset-0 bg-background-app flex items-center justify-center z-50">
        <div className="text-center">
          <div className={`spinner ${sizes.lg} mx-auto mb-4`}></div>
          <p className="text-ink-60">{message}</p>
        </div>
      </div>
    );
  }

  if (type === 'overlay') {
    return (
      <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
        <div className="text-center">
          <div className={`spinner ${sizes[size]} mx-auto mb-2`}></div>
          <p className="text-sm text-ink-60">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <div className={`spinner ${sizes[size]}`}></div>
      {message && <span className="ml-3 text-ink-60">{message}</span>}
    </div>
  );
};

export default Loading;

